import React, { useState } from "react";
import { RiMenuAddFill } from "react-icons/ri";
import { GoSearch } from "react-icons/go";
import BulkImport, {
  UploadModal,
} from "./SubComponents/Component/BulkButton/BulkImport";
import { AiOutlineDelete } from "react-icons/ai";
import Pagination from "./SubComponents/Component/Pagination/Pagination";
import { ServiceCatagories } from "./SubComponents/ServiceCatagories/ServiceCatagories";

const CategoryManagement = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="p-5">
      <div className="border-2 w-full rounded-lg shadow-md">
        {/* Header */}
        <div className="border-b-2 p-4 text-gray-400 text-xl font-semibold">
          <h1>Category Management</h1>
        </div>

        {/* Subheader */}
        <div className="flex justify-center gap-2 mt-5 font-semibold">
          <h1 className="text-red-600 text-xl">ZeroMiddleMan</h1>
          <h1 className="text-xl">Categories</h1>
        </div>

        {/* Description */}
        <div className="w-full flex justify-center mt-2">
          <p className="w-5/6 text-sm text-gray-500 text-center">
            ZeroMiddleMan unique classification of products and services allows
            you to search for companies worldwide by keyword or by code.
            Companies are classified by activity sector (2-digit code), industry
            (5 digits) or product/service (7 digits)
          </p>
        </div>

        {/* Action Icons */}
        <div className="flex justify-center mt-4 mb-5 gap-6 text-gray-500 text-sm">
          <div className="flex items-center gap-2">
            <RiMenuAddFill className="text-xl" />
            <span>this is for Add HSN</span>
          </div>
          <div className="flex items-center gap-2">
            <AiOutlineDelete className="text-xl" />
            <span>this is for Delete HSN</span>
          </div>
        </div>

        {/* Search & Actions */}
        <div className="flex justify-center">
          <div className="border-2 border-b-0 w-5/6 rounded-lg px-4 shadow-md mb-3 flex flex-col items-center">
            <div className="flex flex-wrap justify-evenly items-center gap-4 py-3 mt-3 w-full border-b-2">
              {/* Search Button */}
              <div className="border border-gray-500 flex items-center justify-between rounded-full w-[60%] h-10 px-1 bg-white">
                <input
                  type="text"
                  placeholder="Search HSN"
                  className="w-full outline-none text-sm text-gray-700 bg-transparent h-full px-3"
                />
                <button className="bg-red-600 text-white h-9 px-4 flex items-center gap-2 rounded-full hover:bg-red-700">
                  <GoSearch className="text-lg" />
                  <span className="text-sm">Search</span>
                </button>
              </div>

              {/* Clear Button */}
              <button
                data-tooltip-id="main-tooltip"
                data-tooltip-content="Clear"
                className="text-blue-600 border border-blue-600 rounded-lg px-6 py-1.5 hover:bg-blue-50"
              >
                Clear
              </button>

              {/* Import Button */}
              <BulkImport content="Import" onClick={() => setShowModal(true)} />

              {/* Show Modal */}
              <UploadModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
              />

              {/* Delete Icon */}
              <button
                data-tooltip-id="main-tooltip"
                data-tooltip-content="Delete"
                className="bg-red-500 text-white text-xl p-2 rounded hover:bg-red-600"
              >
                <AiOutlineDelete />
              </button>
            </div>

            {/* Dropdown & Pagination */}
            <div className="w-full border-b">
              <ServiceCatagories />
            </div>
            <div className="w-full mt-3 mb-4">
              <Pagination />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryManagement;
